export default __webpack_public_path__ + "static/media/falta-pouco.cbbddbd8.png";